import * as React from 'react';
import { Row, Col } from 'antd';
import { observer } from 'mobx-react';
import { Prompt } from 'react-router';

import { HeaderView } from 'src/app/shared/header.view';
import { DataTableView, ToolbarVisibility, Column } from 'src/core/ui/data-table.view';
import { BooleanView } from 'src/core/ui/boolean.view';
import { PlaceEditorController } from 'src/app/general/places/parts/place-editor.controller';
import { RegionEditorController } from 'src/app/general/regions/parts/region-editor.controller';
import { ProductEditorController } from 'src/app/products/products/parts/product-editor.controller';
import { DropdownView } from '../../../core/ui/dropdown.view';

interface Props extends ComponentViewProps<DataSet<EntityMappingItem>> {
	title: string,
	mode: ControlMode;
	save: () => void,
	cancel: () => void,
	onModeChanged: (mode: ControlMode) => void;
}

@observer
export class EntityMappingView extends React.Component<Props, {}> {
	columns: Column[] = [
		{
			key: 'typeText',
			dataIndex: 'typeText',
			title: 'Data type',
			filter: {
				field: 'type',
				type: 'number',
				render: (value, onChange) => (
					<DropdownView
						label={null}
						onChanged={this.filterChange(onChange)}
						model={value}
						options={
							[
								{ value: 0, label: 'Region' },
								{ value: 1, label: 'Place' },
								{ value: 2, label: 'Product' },
								{ value: 3, label: 'Supplier' },
								{ value: 4, label: 'Airline' },
							]
						}
					/>
				)
			}
		},
		{
			key: 'bookemKey',
			dataIndex: 'bookemKey',
			editable: (text: any, record: EntityMappingItem, index: number, isSelected: boolean) => {
				if (!isSelected || this.props.mode === 'display') {
					return text || 'No set';
				}
				switch (record.type) {
					case 0:
						return (
							<RegionEditorController
								label={null}
								mode={(record.productProviderId != 1) ? this.props.mode : 'display'}
								onChanged={(value) => {
									record.bookemKey = value != null ? value.id.toString() : null;
								}}
								value={record.bookemKey ? parseInt(record.bookemKey) : undefined}
								setBusy={this.props.setBusy}
							/>
						);
					case 1:
						return (
							<PlaceEditorController
								label={null}
								mode={(record.productProviderId != 1) ? this.props.mode : 'display'}
								onChanged={(value) => {
									record.bookemKey = value != null ? value.id.toString() : null;
								}}
								value={record.bookemKey ? parseInt(record.bookemKey) : undefined}
								setBusy={this.props.setBusy}
							/>
						);
					case 2:
						return (
							<ProductEditorController
								label={null}
								mode={(record.productProviderId != 1) ? this.props.mode : 'display'}
								onChanged={(value) => {
									record.bookemKey = value != null ? value.id.toString() : null;
								}}
								value={record.bookemKey ? parseInt(record.bookemKey) : undefined}
								setBusy={this.props.setBusy}
							/>
						);
				}

				return null;
			},
			title: 'Bookem Data'
		},
		{
			key: 'productProviderName',
			dataIndex: 'productProviderName',
			title: 'Provider Name'
		},
		{
			key: 'displayName',
			dataIndex: 'displayName',
			title: 'Provider Title'
		},
		{
			key: 'productProviderKey',
			dataIndex: 'productProviderKey',
			title: 'Provider Key'
		},
		{
			key: 'isChekedByUser',
			dataIndex: 'isChekedByUser',
			title: 'Is checked by user',
			render: (text, record: EntityMappingItem, index) => (
				<BooleanView
					size="small"
					label={null}
					mode="display"
					value={record.isCheckedByUser}
				/>
			)
		}
	];

	constructor(props: Readonly<Props>) {
		super(props);
	}

	public render() {
		if (this.props.model == null) {
			return null;
		}

		return (
			<div className="window window-normal">
				<Prompt
					when={this.props.model.isDirty}
					message={location => `If you go to ${location.pathname}, all changes will be lost. Are you sure you want to continue?`}
				/>
				{
					this.props.save &&
					<Row>
						<Col xs={24}>
							<HeaderView
								title={this.props.title}
								mode={this.props.mode}
								onModeChanged={this.props.onModeChanged}
								save={this.props.save}
								cancel={this.props.cancel}
								contextService={this.props.model}
							/>
						</Col>
					</Row>
				}
				<div className="card">
					<Row>
						<Col xs={24}>
							<DataTableView
								rowKey="id"
								columns={this.columns}
								mode={this.props.mode}
								setBusy={this.props.setBusy}
								model={this.props.model}
								hideToolbar={ToolbarVisibility.hideModifyButtons}
							/>
						</Col>
					</Row>
				</div>
			</div>
		)
	}
	
	private filterChange = (onChange: (newValue: any) => void) => (newValue: any) => {
		onChange(newValue ? newValue.value : undefined);
	}
}



// WEBPACK FOOTER //
// ./src/app/products/entity-mappings/entity-mapping.view.tsx